import { Navigate } from "react-router-dom";

/** @deprecated — library lives on Chatbots under the Library tab */
const DefaultChatbotsView = () => (
  <Navigate to="/automation/chatbots?view=library" replace />
);

export default DefaultChatbotsView;
